<template>
    <div>
        <mvtListProperty :cardFilter="cardFilter" :data="getSortedData" v-if="getSortedData && getSortedData.length" :type="type" @selectItem="sendSelectItem"></mvtListProperty>
        <div class="mvt-neary-noresult" v-else>
            <i class="icon-search f1"></i> {{molang('dpp.mvtNearby.noResults')}}
        </div>
    </div>
</template>
<script src="./mvt-nearby.js"></script>

<style lang="scss">
@use "./mvt-nearby.scss" as *;
</style>
